export const IELTS = 'IELTS'
export const APTIS = 'Aptis'